import React from "react";
import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTASection } from "@/components/CTASection";
import { CountUp } from "@/components/CountUp";
import { STATS, WHY, IMG } from "@/data/content";

export default function OverOns() {
  useSeo({
    title: "Over ons | Imperium Group",
    description: "Imperium Group is een full-service marketingbureau dat álle vormen van marketing onder één dak brengt — van digitaal tot telemarketing, TV, radio en buitenreclame.",
    path: "/over-ons",
  });

  return (
    <div data-testid="over-ons-page">
      <PageHero
        overline="Over ons"
        title="Jouw partner voor álle marketing"
        subtitle="Imperium Group brengt het complete marketingspectrum samen in één bureau — met eigen creatie-, campagne- en telemarketingteams."
        image={IMG.heroOffice}
      />

      <section className="pb-20">
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-6 lg:grid-cols-2 lg:px-10">
          <Reveal>
            <div className="relative overflow-hidden rounded-3xl border border-white/10">
              <img src={IMG.team} alt="Team van Imperium Group" className="h-[440px] w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#090B0E] via-transparent to-transparent" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-3xl font-bold tracking-tight text-white lg:text-4xl">Eén bureau, het hele spectrum</h2>
            <p className="mt-6 text-lg leading-relaxed text-slate-300">
              Waar de meeste bureaus zich op één kanaal richten, doen wij het tegenovergestelde: wij bieden echt álles op het gebied van marketing. Digitaal én traditioneel, online én op straat.
            </p>
            <p className="mt-4 text-base leading-relaxed text-slate-400">
              Van SEO en social advertising tot telemarketing, televisie, radio, billboards en sportsponsoring — alles perfect op elkaar afgestemd. Zo bouwen we merken die overal zichtbaar zijn en campagnes die meetbaar presteren.
            </p>
            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {WHY.map((w) => (
                <div key={w.title} className="rounded-2xl border border-white/10 bg-[#12151D] p-5">
                  <h3 className="font-display text-base font-semibold text-white">{w.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{w.text}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-10">
        <div className="mx-auto grid max-w-6xl grid-cols-2 gap-6 px-6 lg:grid-cols-4 lg:px-10">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="rounded-2xl border border-white/10 bg-[#12151D] p-7 text-center">
                <CountUp value={s.value} className="font-display text-4xl font-extrabold flame-text lg:text-5xl" />
                <div className="mt-2 font-mono text-xs uppercase tracking-[0.15em] text-slate-400">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
